import React from "react";

import { getRelationName } from "../../bottom_content/view/panes/east/element-details/ElementDetailsUtils";
import type { FullComponent, FullRelation } from "../../common/openapi";
import { DrawerComponentTitle, DrawerTitle } from "../react/drawer/ExplorationDrawer";
import { StateRelation } from "../react/states/StateRelation";
import { fullToSimpleRelation } from "../react/states/state-relation-utils";

interface ElementDrawerTitleProps {
	fullElement: FullComponent | FullRelation;
	typeOfData: string;
}

export const ElementDrawerTitle: React.FC<ElementDrawerTitleProps> = ({ fullElement, typeOfData }) => {
	if ("actions" in fullElement) {
		return <DrawerComponentTitle component={fullElement} displayTypeName typeOfData={`Component ${typeOfData}`} />;
	}

	return (
		<DrawerTitle
			icon={<StateRelation relation={fullToSimpleRelation(fullElement)} />}
			title={getRelationName(fullElement, fullElement.typeName)}
			typeOfData={`Relation ${typeOfData}`}
		/>
	);
};
